import { useEffect, useState } from 'react';

/** Observa uma media query e retorna se ela está ativa. */
export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() =>
        typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
    );

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = () => setMatches(mql.matches);
        onChange();
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}

/** Breakpoint do shell Nexus em que a sidebar vira drawer (mobile). */
export function useIsMobileShell(): boolean {
    return useMediaQuery('(max-width: 991px)');
}
